'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const RouteChangeScript = ({ code }: { code: string }) => {
  const pathname = usePathname();

  useEffect(() => {
    let script: HTMLScriptElement | null = null;

    const removeWidgetIframes = () => {
      return new Promise<void>((resolve, reject) => {
        try {
          // Sélectionner les iframes avec id commençant par "ps_w_"
          const iframes = document.querySelectorAll('iframe[id^="ps_w_"]');

          iframes.forEach((element) => {
            const iframe = element as HTMLIFrameElement;
            try {
              iframe.contentWindow?.postMessage({ type: 'cleanup' }, '*');
            } catch (e) {}
            iframe.remove();
          });
          console.log(`Removed ${iframes.length} widget iframe(s)`);
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    };

    const removeWidgetElements = () => {
      removeWidgetIframes();

      const externalScript = document.querySelector('script[src*="LB_widget.js"]');
      if (externalScript) {
        externalScript.remove();
      }

      // Supprimer d'autres éléments du widget si nécessaire
      const widgetElements = document.querySelectorAll('[id*="ps_w_"]');
      widgetElements.forEach((element) => {
        if (element.tagName !== 'SCRIPT' || !element.id.includes('louiseBot_widget')) {
          element.remove();
        }
      });

      // Nettoyer le localStorage
      localStorage.removeItem('ps_widget');
    };

    removeWidgetElements();

    setTimeout(() => {
      script = document.createElement('script');
      script.innerHTML = `
        !(function () { function g() {
          var script = document.createElement('script'), code = '${code}' ,url = 'https://cdn.1cdn.app/application/LB/23082315255659_LB_widget.js', l = localStorage.setItem('ps_widget' , code);
          (script.type = 'text/javascript'),(script.async = !0),(script.src = url);
          document.getElementsByTagName('head')[0].appendChild(script);          
        }

        document.readyState === 'complete' ? g() : window.attachEvent ? window.attachEvent('onload', g)
        : window.addEventListener('load', g, !1);
        })();        
      `;
      script.id = 'louiseBot_widget';
      document.head.appendChild(script);
    }, 200);

    return () => {
      removeWidgetElements();
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [pathname, code]);

  return null;
};

export default RouteChangeScript;
